import Vue from "vue";
import Vuex from "vuex";
import { authStore } from "src/lt-module/auth-module";
import http from "src/lt-module/utils/http.js";
import { GeneralService } from "src/lt-module/general-module/GeneralService.js";
// import { displayStore } from "src/lt-module/utils/displayStore.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {},
    config: {}
  },
  getters: {
    logged(state) {
      return state.user && !!state.user.id;
    }
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setConfig(state, newConfig) {
      state.config = newConfig;
    }
  },
  actions: {
    async getUser({ commit }) {
      let user = await GeneralService.getUser();
      commit("setUser", user);
      commit("setConfig", user.config);
    },
    async authAfterLogged({ dispatch }) {
      await dispatch("getUser");
    }
  },
  modules: {
    auth: authStore(http)
    // display: displayStore
  }
});
